module.exports = {
      id: "books-vikatan-usage",
      viewBox: "0 0 22 29.5",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#books-vikatan",
      toString: function () {
        return this.url;
      }
    }